import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import logo from '../../assets/images/logo.png'
import './index.scss'

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  const handleToggleMenu = () => {
    if (menuOpen) {
      setIsClosing(true)
      setTimeout(() => {
        setMenuOpen(false)
        setIsClosing(false)
      }, 500)
    } else {
      setMenuOpen(true)
    }
  }

  const handleCloseMenu = () => {
    setMenuOpen(false)
    setIsClosing(false)
  }

  return (
    <header className="navbar">
      <div className="navbar__content">
        <NavLink to="/" className="navbar__logo" onClick={handleCloseMenu}>
          <img src={logo} alt="Ella Lee Dev Logo" />
        </NavLink>

        <div
          className={`navbar__links ${menuOpen ? 'open' : ''} ${
            isClosing ? 'closing' : ''
          }`}
        >
          <NavLink
            exact="true"
            to="/"
            activeClassName="active"
            onClick={handleCloseMenu}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            activeClassName="active"
            onClick={handleCloseMenu}
          >
            About
          </NavLink>
          <NavLink
            to="/projects"
            activeClassName="active"
            onClick={handleCloseMenu}
          >
            Projects
          </NavLink>
          <NavLink
            to="/contact"
            activeClassName="active"
            onClick={handleCloseMenu}
          >
            Contact
          </NavLink>
        </div>

        <button
          className={`burger ${menuOpen ? 'open' : ''}`}
          onClick={handleToggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  )
}

export default Navbar
